import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import logo from "../Components/images/logo.png";
import { useNavigate } from "react-router-dom";


export default function Login() {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
const navigate = useNavigate();


  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };


const handleLogin = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const res = await axios.post("https://dropshopi.com/api/login.php", formData);

    if (res.data.status === "success") {
      localStorage.setItem("user_id", res.data.user_id);
      alert("Login successful!");
      navigate("/add-blog"); // Navigate to add-blog page
    } else {
      alert(res.data.message || "Login failed.");
    }
  } catch (err) {
    console.error(err);
    alert("Something went wrong. Please try again.");
  }

  setLoading(false);
};


  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="d-flex justify-content-center align-items-center min-vh-100 bg-dark text-white"
    >
      <div className="p-5 rounded-4 shadow-lg" style={{ maxWidth: "400px", width: "100%", background: "#1f1f1f" }}>
        <div className="text-center mb-4">
          <img src={logo} alt="Logo" style={{ width: 80, height: 80 }} />
          <h2 className="mt-3">Welcome Back</h2>
          <p className="text-secondary">Login to your account</p>
        </div>

        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email address</label>
            <input
              type="email"
              className="form-control bg-dark text-white border-secondary"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
            />
          </div>

          <div className="mb-4">
            <label htmlFor="password" className="form-label">Password</label>
            <input
              type="password"
              className="form-control bg-dark text-white border-secondary"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
            />
          </div>

          <button
            type="submit"
            className="btn btn-warning w-100 py-2 d-flex justify-content-center align-items-center"
            disabled={loading}
          >
            {loading ? (
              <span className="spinner-border spinner-border-sm text-light" role="status" aria-hidden="true"></span>
            ) : (
              "Login"
            )}
          </button>
        </form>
      </div>
    </motion.div>
  );
}
